import { useState, useEffect } from "react";
import { Typography, Row, Col, Input, Select, Alert, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllCompanyNames,
  setAllDepartmentNames,
} from "../../redux/actions/mainAction";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const AddPosition = () => {
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);
  const dispatch = useDispatch();

  const [positionName, setPositionName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [employeeCount, setEmployeeCount] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Vəzifə əlavə edildi!",
    });
  };

  useEffect(() => {
    getAllCompanyNames();
    getAllDepartmentNames();
  }, [GlobalResponse.triggeranyevent]);

  const getAllCompanyNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-company-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllCompanyNames(uniqueResults));
  };

  const getAllDepartmentNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-department-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllDepartmentNames(uniqueResults));
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const handleChangeDepartment = (value) => {
    setDepartmentName(value);
  };

  const savePosition = async () => {
    if (positionName && departmentName && companyName) {
      setShowAlert(false);
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/add-position/`,
        {
          method: "post",
          body: JSON.stringify({
            positionName,
            companyName,
            departmentName,
            employeeCount,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);
        dispatch(setTriggerAnyEvent(Math.random()));
        setPositionName("");
        setDepartmentName("");
        setCompanyName("");
        openNotificationWithIcon("success");
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {contextHolder}
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}

      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Vəzifənin adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={positionName}
            onChange={(e) => setPositionName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            value={companyName}
            onChange={handleChangeCompany}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şöbə</Typography.Text>

          <Select
            size="large"
            value={departmentName}
            onChange={handleChangeDepartment}
            className="add-dropdown"
            options={MainResponse.allDepartmentNames}
          />
        </Col>
        <Col span={6}>
          <button
            disabled={buttonDisable}
            onClick={savePosition}
            className="add-button"
          >
            Əlavə Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default AddPosition;
